import { styled } from '@mui/material';

const LoginCarousel = styled('div', {
  name: 'LoginBanner',
  slot: 'carousel',
})({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '90px',
  maxWidth: '428px',
});

const Carousel = () => {
  return (
    <LoginCarousel>
      <div className='flex flex-col items-center'>
        <div className='carousel-title text-[32px] font-semibold text-center'>Programmatic done well</div>
        <div className='carousel-text text-center'>
          Enter here to access the tools you need to make the complex programmatic ecosystem simple.
        </div>
      </div>
    </LoginCarousel>
  );
};

export default Carousel;
